/* eslint-disable no-param-reassign */
import { assert } from '@ember/debug';

// **Stop!** Do not use this in new code. This tool exits to assist with
// migrating from Computed Properties to auto-tracked getters.
//
// Computed Properties, prior to Ember 4, were overridable by default. This
// behavior was deprecated in Ember 3.9 and removed in Ember 4. Typically,
// overwriting CPs would only be done for convenience by test code.
//
// https://deprecations.emberjs.com/v3.x/#toc_computed-property-override
//
// This decorator exists to defer the work of updating every place in test code
// that was making use of overridable behavior when converting from CPs to getters.
//
// This decorator does not make typescript understand that the property will
// have a getter. If you want to write to a property from a ts file, you'll
// need to manually add a set function instead of using this decorator.
//
// Correct ways to do this in new code include:
//  * Mutate the values read by the getter
//  * Use a sinon stub's `stub.get(getterFn)` feature to mock the getter function
//
// @deprecated
// @decorator allowDeprecatedOverrides
export default function allowDeprecatedOverrides(_target, _key, desc) {
  const {
    set: originalSet,
    get: originalGet
  } = desc;
  assert('You must define a getter to use `allowDeprecatedOverrides`', originalGet);
  assert('You may not define a setter when using `allowDeprecatedOverrides`', !originalSet);
  const OVERRIDE_MAP = new WeakMap();
  desc.set = function overrideSetter(value) {
    OVERRIDE_MAP.set(this, value);
  };
  desc.get = function testOnlyGetter() {
    if (OVERRIDE_MAP.has(this)) {
      return OVERRIDE_MAP.get(this);
    }
    return originalGet.apply(this);
  };
  return desc;
}

/* eslint-enable no-param-reassign */